import { getErrorMessage } from './error.utils.js';
export const tryCatch = async (asyncFn) => {
    try {
        const data = await asyncFn();
        return [data, null];
    }
    catch (err) {
        const error = new Error(getErrorMessage(err));
        return [null, error];
    }
};
export class UnauthorizedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'UnauthorizedError';
    }
}
export const makeZodSafeFetch = (url, schema, options) => fetch(url, options)
    .then((res) => {
    if (res.status === 401) {
        throw new UnauthorizedError('Unauthorized');
    }
    if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
    }
    return res.json();
})
    .then((res) => schema.parse(res))
    .catch((error) => {
    if (error instanceof UnauthorizedError) {
        throw error;
    }
    if (error instanceof Error) {
        // undici surfaces the real reason (ENOTFOUND / cert / timeout) on
        // .cause, which is dropped if we only keep the generic 'fetch failed'
        // message.
        const cause = error.cause instanceof Error ? `: ${error.cause.message}` : '';
        throw new Error(`Failed to fetch and validate data from ${url}: ${error.message}${cause}`);
    }
    throw new Error(`Failed to fetch and validate data from ${url}: ${String(error)}`);
});
export const makeZodSafeFetchWithErrors = async (url, schema, options) => {
    try {
        const response = await fetch(url, options);
        if (response.status === 401) {
            return { success: false, error: new UnauthorizedError('Unauthorized') };
        }
        if (!response.ok) {
            return {
                success: false,
                error: new Error(`HTTP ${response.status}: ${response.statusText}`),
            };
        }
        const json = await response.json();
        const result = schema.safeParse(json);
        if (result.success) {
            return { success: true, data: result.data };
        }
        return { success: false, error: result.error };
    }
    catch (error) {
        if (error instanceof UnauthorizedError) {
            return { success: false, error };
        }
        if (error instanceof Error) {
            // undici surfaces the real reason (ENOTFOUND / cert / timeout) on .cause,
            // which is dropped if we only keep the generic 'fetch failed' message.
            const cause = error.cause instanceof Error ? `: ${error.cause.message}` : '';
            return { success: false, error: new Error(`${error.message}${cause}`) };
        }
        return { success: false, error: new Error('Unknown error') };
    }
};
//# sourceMappingURL=async.utils.js.map